import { escapeSpecialCharacters } from 'ui-beta/searchableText';

// Checks if at least one value in the expanded cell matches searched text
export const isExpandedDataMatched = (
  experimentId: number,
  campaignId: number,
  searchText: string,
) => {
  if (!searchText.length) return false;
  const trimmedCombinedIds = `${experimentId}${campaignId}`;
  const searchRegex = new RegExp(escapeSpecialCharacters(searchText), 'gi');
  return !!Array.from(trimmedCombinedIds.matchAll(searchRegex), (match) => match[0]).length;
};
